<template>
  <div class="device-doorlock">
    <div class="page-search-block">
      <div class="m-b-18">
        <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
        <div class="inline-block" style="display: flex; align-items: center">
          <span class="w-90 inline-block align-r m-r-8">租客：</span>
          <el-input
            v-model="tenantSearchKey"
            class="w-300 m-r-10"
            placeholder="请输入租客姓名或手机号码查询"
          ></el-input>
          <el-button class="submit-btn" @click="getQuery" type="primary"
            >搜索</el-button
          >
          <el-button @click="reset">重置</el-button>
        </div>
      </div>
    </div>

    <div class="statistics">
      <div class="statistics-item">
        <div class="item-title">客户总量</div>
        <div class="item-count">{{ statisticsData.tenantCount || 0 }}</div>
      </div>
      <div class="statistics-item">
        <div class="item-title">累计入住人次</div>
        <div class="item-count">{{ statisticsData.checkInCount || 0 }}</div>
      </div>
      <div class="statistics-item">
        <div class="item-title">今日新增客户</div>
        <div class="item-count">{{ statisticsData.todayAddTenantCount || 0 }}</div>
      </div>
    </div>

    <div class="operations">
      <i class="iconfont show-more" :class="isShowMore ? 'wyf-yanjing_kai' : 'wyf-yanjing_bi'" @click="isShowMore = !isShowMore"></i>
      <el-button @click="manageLabel" type="warning">标签管理</el-button>
      <el-button @click="batchAddLabel" plain type="warning">打标签</el-button>
    </div>

    <div class="table-list-block">
      <r-table
        ref="tenantTable"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      >
        <el-table-column
          label="租客姓名"
          width="100px"
          show-overflow-tooltip
        >
          <template #default="{row}">
            {{isShowMore ? row.tenantName : filterName(row.tenantName)}}
          </template>
        </el-table-column>
        <el-table-column
          label="手机号"
          show-overflow-tooltip
          width="140px"
        >
          <template #default="{row}">
            {{isShowMore ? row.tenantPhone : filterPhone(row.tenantPhone)}}
          </template>
        </el-table-column>
        <el-table-column label="标签" width="220px">
          <template #default="{ row }">
            <template v-if="row.labelList">
              <el-tag 
                v-for="(label, i) of row.labelList" 
                :key="i" 
                style="margin: 0 4px 4px 0;"
                closable
                effect="plain"
                @close="handleTagClose(row, label)"
              >{{label.labelName}}</el-tag>
            </template>
            <el-tag @click="addLabel(row)" style="cursor: pointer;">添加标签</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="生日"
          width="120px"
          show-overflow-tooltip
        >
        <template #default="{ row }">
          {{ row.birthday && row.birthday.slice(5) }}
        </template>
        </el-table-column>
        <el-table-column
          prop="totalCost"
          label="累计消费金额"
          width="120px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="checkInTimes"
          label="累计入住次数"
          width="120px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="lastCheckInTime"
          label="最近一次入住时间"
          width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="operate" label="操作" show-overflow-tooltip width="100px">
          <template #default="scope">
            <el-button
              class="border-btn primary"
              size="small"
              @click="previewCheckInRecord(scope.row.id)"
              >入住记录</el-button
            >
          </template>
        </el-table-column>
      </r-table>
    </div>
    <RModal
      customClass="renant-modal"
      title="入住记录"
      v-model="checkInRecordModalShow"
      :closeOnClick="false"
      @change="checkInRecordModalShow = false"
    >
      <template v-slot:content>
        <check-in-record-modal
          v-if="checkInRecordModalShow"
          :tenantId="currentTenantId"
          @close="closeModal"
        ></check-in-record-modal>
      </template>
    </RModal>
    <el-dialog v-model="labelDialogVisible" title="添加标签" @close="handleLabelDialogClose">
      <div style="display: flex; align-items: center; margin-bottom: 16px;">
        <el-input v-model="labelFilter.labelName" placeholder="请输入标签名称" style="margin-right: 16px;"/>
        <el-button @click="getLabelList" type="primary">搜索</el-button>
      </div>
      <el-table
        ref="labelTableRef"
        :data="labelList"
        @selection-change="handleLabelSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="labelName" label="标签名称" />
        <el-table-column prop="labelDescription" label="标签说明" />
      </el-table>
      <div class="footer">
        <el-button type="primary" @click="confirmLabelDialog">确定</el-button>
        <el-button @click="handleLabelDialogClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RModal from "@/components/common/RModal";
import RTable from "@/components/common/RTable";
import tableMix from "@/components/common/tableListMixin.js";
import { mapActions } from "vuex";
import checkInRecordModal from "./checkInRecordModal";

export default {
  name: "Tenant",
  components: { RModal, RTable, checkInRecordModal },
  mixins: [tableMix],
  data() {
    return {
      tenantSearchKey: "",
      labelId: "",
      tableData: [],
      tableColumn: [],
      pagination: { pageIndex: 1, pageSize: 20, total: 0 },
      checkInRecordModalShow: false,
      currentTenantId: null,
      statisticsData: {},
      labelDialogVisible: false,
      labelFilter: {
        labelName: "",
      },
      labelList: [],
      selectedLabelList: [],
      selectedTenant: null,
      isShowMore: false
    };
  },

  created() {
    this.$eventBus.on('labelIdChange', this.handleLabelIdChange);
    this.getStatistics();
    this.getQuery();
    this.initTableColumn();
    this.getLabelList();
  },

  mounted() {
    this.$nextTick(() => {
      $(".shopSel") && $(".shopSel").hide();
    });
  },

  beforeUnmount() {
    $(".shopSel") && $(".shopSel").show();
  },

  beforeRouteLeave() {
    $(".shopSel") && $(".shopSel").show();
  },

  methods: {
    ...mapActions(["fetchData"]),
    handleLabelIdChange(id){
      this.labelId = id;
      this.getQuery();
    },
    reset(){
      this.tenantSearchKey = "";
      this.labelId = "";
      this.getQuery();
    },
    confirmLabelDialog(){
      this.fetchData({
        url: "TENANT.ADD_LABEL",
        method: "post",
        headers: { 'Content-Type': 'application/json' },
        params: {
          labelIds: this.selectedLabelList.map(e => e.id),
          tenantIds: this.selectedTenant ? [this.selectedTenant] : this.options.selection.map(e => e.id),
        },
      }).then(() => {
        this.handleLabelDialogClose();
        this.selectedTenant = null;
        this.getQuery();
      });
    },
    handleLabelDialogClose(){
      this.labelDialogVisible = false;
      this.$refs.labelTableRef.clearSelection();
      this.labelFilter.labelName = "";
    },
    getLabelList(){
      return this.fetchData({
        url: "LABEL.LIST",
        method: "get",
        headers: { 'Content-Type': 'application/json' },
        params: {
          labelName: this.labelFilter.labelName,
        },
      }).then(res => {
        this.labelList = res ? res.data : []
      });
    },
    handleLabelSelectionChange(rows){
      console.log(this.selectedLabelList);
      this.selectedLabelList = rows;
    },
    manageLabel() {
      this.$emit('changeActive', 'label');
    },
    batchAddLabel() {
      if(!this.options.selection.length){
        return this.$message.error('请选择租客');
      }
      this.selectedLabelList = this.options.selection;
      this.labelDialogVisible = true;
    },
    async addLabel(row) {
      await this.getLabelList();
      this.labelDialogVisible = true;
      this.selectedTenant = row.id;
    },
    handleTagClose(row, label){
      this.$confirm(`是否确定删除客户「${row.tenantName}」的标签「${label.labelName}」？`).then(() => {
        this.fetchData({
          url: "TENANT.DELETE_LABEL",
          method: "post",
          headers: { "Content-Type": "application/json" },
          params: [label.relationId],
        }).then(this.getQuery);
      });
    },
    getStatistics() {
      this.fetchData({
        url: "TENANT.STATISTICS",
        method: "get",
      }).then((data) => {
        this.statisticsData = data;
      });
    },

    // 获取table数据
    getQuery() {
      this.fetchData({
        url: "TENANT.LIST",
        method: "get",
        params: {
          tenantSearchKey: this.tenantSearchKey,
          pageSize: this.pagination.pageSize,
          pageNumber: this.pagination.pageIndex,
          labelId: this.labelId,
        },
      }).then((res) => {
        this.tableData = res?.data || [];
        this.pagination.total = res?.rowCount || 0;
      });
    },

    // 初始化table字段
    initTableColumn() {
      this.tableColumn = [
        { prop: "tenantName", label: "租客姓名" },
        { prop: "tenantPhone", label: "手机号" },
        { prop: "sex", label: "性别" },
        { prop: "birthday", label: "生日" },
        { prop: "checkInTimes", label: "累计入住次数" },
        { prop: "lastCheckInTime", label: "最近一次入住时间" },
        { prop: "lastCheckInStoreName", label: "最近一次入住门店" },
        { prop: "operate", label: "操作" },
      ];
    },

    // 入住记录
    previewCheckInRecord(tenantId) {
      this.currentTenantId = tenantId;
      this.checkInRecordModalShow = true;
    },

    // 关闭新增编辑弹框
    closeModal() {
      this.checkInRecordModalShow = false;
    },
    filterName(name){
      if(name && name.length){
        const len = name.length;
        if(len == 1){
          return name;
        }else if(len == 2){
          return name[0] + '*';
        }else{
          return name[0] + new Array(len - 2).fill("*").join('') + name[len - 1]
        }
      }else{
        return name;
      }
    },
    filterPhone(phone){
      return phone.slice(0, 3) + "****" + phone.slice(7);
    }
  },
};
</script>

<style scoped lang="less">
.device-doorlock {
  background-color: white;
  border-radius: 8px;
  .operations{
    display: flex;
    justify-content: flex-end;
    padding: 0 25px;
    margin-top: 25px;
    .show-more{
      font-size: 20px;
      cursor: pointer;
      margin-right: 8px;
    }
  }
  .statistics {
    display: flex;
    padding: 0 25px;
    .statistics-item {
      flex-grow: 1;
      border-radius: 8px;
      background: #ffffff;
      box-shadow: 1px 1px 2px 0px rgba(82, 90, 102, 0.04),
        2px 2px 8px 0px rgba(82, 90, 102, 0.08);
      padding: 24px 36px 20px;
      margin-right: 44px;
      &:last-child {
        margin-right: 0;
      }
      .item-title {
        font-size: 20px;
        color: #091136;
      }
      .item-count {
        font-size: 40px;
        color: #091136;
        text-align: center;
      }
    }
  }
}
.footer{
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
<style lang="less">
.renant-modal.el-dialog {
  width: 80% !important;
}
</style>